import React from 'react';
import { Empty } from 'antd';
import emptyImg from '@/assets/img/empty.png';
import './noData.less';

/**
 * 加载组件
 * @param {*} param
 */
const NoData = ({ loading }) => {
  return (
    <>
      {!loading && (
        <Empty
          image={emptyImg}
          imageStyle={{
            width: 46,
            height: 46,
          }}
          className="empty-comm"
        />
      )}
      {/* <span style={{ color: '#8c8c8c' }}>暂无数据</span> */}
    </>
  );
};

export default NoData;
